// Shared rule for who may delete a testator's documents from the UI.
// The testator may delete their own documents, and an admin may delete (including
// an admin impersonating the testator). Advisers and other staff roles — including
// an adviser impersonating the testator — may not. The backend enforces the same rule.
export const documentDeletePermissionMixin = {
  computed: {
    canDeleteDocuments() {
      const { isLoggedInAsSomeoneElse, isAdminLoggedInAsSomeoneElse } =
        this.$store.getters;
      return !isLoggedInAsSomeoneElse || isAdminLoggedInAsSomeoneElse;
    },
  },
};
